/// <amd-module name="Tfs/Frame/Components/UserMenuItem/UserMenuItem" />
import React = require("react");

import { getIdentityImageUrl, IdentityImageSize } from "VSS/Platform/Identity";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";

import { IMenuItemProps } from "VSSUI/Menu";

/* @TODO: Move to somewhere outside the page project. This can be brought in async. */

/**
 * UserMenuComponent is used to render the owner draw menuitem in the profile menu
 * that shows the users basic profile information.
 */
class UserMenuItem extends VssComponent<IMenuItemProps> {
    private userDisplayName: string;
    private userUniqueName?: string;
    private userImageUrl: string;

    public constructor(props: IMenuItemProps, context: IVssComponentContext) {
        super(props, context);

        const pageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();

        if (pageData && pageData.user) {
            this.userDisplayName = pageData.user.displayName;
            this.userUniqueName = pageData.user.uniqueName;
            this.userImageUrl = getIdentityImageUrl(context.pageContext, pageData.user, IdentityImageSize.medium);
        }
    }

    public render(): JSX.Element {
        return (
            <tr
                aria-posinset={this.props.details.position}
                aria-setsize={this.props.details.setSize}
                className="bolt-menuitem-row bolt-list-row user-menuitem-row"
                role="presentation"
            >
                <td className="bolt-menuitem-cell bolt-list-cell" />
                <td className="bolt-menuitem-cell bolt-list-cell" colSpan={5}>
                    <div className="flex-row flex-center">
                        <img className="user-menu-item-image" src={this.userImageUrl} alt="" />
                        <div className="user-menu-item-details">
                            <div>{this.userDisplayName}</div>
                            <div className="user-menu-item-unique-name">{this.userUniqueName}</div>
                        </div>
                    </div>
                </td>
                <td className="bolt-menuitem-cell bolt-list-cell" />
            </tr>
        );
    }
}

Components.add("userMenuItem", UserMenuItem);
